<template>
    <div id="newViewDropdown" class="dropdown">
        <button class="btn btn-light btn-sm dropdown-toggle" type="button" id="viewDropdown"
                data-bs-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
            {{view.name}} <i class="fas fa-caret-down"></i>
        </button>

        <div class="dropdown-menu view-options-dropdown" aria-labelledby="viewDropdown">

            <router-link v-for="availableView in table.views"
                         :to="{ name: 'view-renderer', params: {id: availableView.id}}"
                         class="dropdown-item" :class="availableView.id === view.id ? 'active' :''"
                         :key="availableView.id + 'ViewLink'">
                {{availableView.name}}
            </router-link>

            <div class="dropdown-divider"></div>

            <div @click="onNewClick" class="pointer dropdown-item">
                <i class="fad fa-plus-circle text-secondary me-2"></i>
                <a class="text-secondary no-underline" href="javascript:void(0)">new view</a>
            </div>

        </div>

        <view-modal :key="'new-view-dropdown-on-' + table.id" v-if="showViewEditor" :table="table"
                    :view="newView" @noEvent="showViewEditor = false"></view-modal>
    </div>
</template>

<script>

    import ViewService from "../../services/ViewService";
    import ViewModal from "../../editor/app/ViewModal.vue";

    export default {
        name: 'ViewsDropdown',
        components: {ViewModal},
        props: ['table', 'view'],
        data() {
            return {
                model: webase.model,
                service: new ViewService(),
                showViewEditor: false,
                newView: {
                    name: '',
                    view_type: 'list',
                    model_id: this.table.id,
                    published: false,
                    group_field_id: null,
                    layout: {
                        description: ''
                    },
                    id: null
                },
                alertMessage: null
            }
        },
        methods: {

            onNewClick() {
                this.newView = {
                    name: '',
                    view_type: 'list',
                    model_id: this.table.id,
                    published: false,
                    group_field_id: null,
                    layout: {
                        description: ''
                    },
                    id: null
                }

                this.showViewEditor = true
            }
        }
    }
</script>
